import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { Customer } from '../../../../types/schema/customer.types';
import { PaginationInput } from '../../../../types/schema/utils.types';

interface GetAllCustomersByPageHook {
  data: Customer[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllCustomersByPage: Customer[];
    }>
  >;
}

interface GetAllCustomersByPageMutationData {
  getAllCustomersByPage: Customer[];
}

interface GetAllCustomersByPageInputType {
  input: PaginationInput;
}

export function useGetAllCustomersByPage(
  query: DocumentNode,
  input: PaginationInput
): GetAllCustomersByPageHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    GetAllCustomersByPageMutationData,
    GetAllCustomersByPageInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllCustomersByPage,
    loading,
    error,
    refetch,
  };
}
